// extracted by mini-css-extract-plugin
export default {"container":"TabIndicator__container-wJEEm","item":"TabIndicator__item-_duil","active":"TabIndicator__active-CHk6l"};